import React from 'react';
import Tethered from 'src/components/Tethered';
import cx from 'classnames';

const attachmentMap = {
  top: 'bottom center',
  right: 'middle left',
  bottom: 'top center',
  left: 'middle right',
};

function BootstrapPopover(props) {
  const { getTarget, children, type, title, placement, active, ...rest } = props;
  const attachment = (placement && attachmentMap[placement]) || attachmentMap.top;
  const className = cx({
    popover: true,
    popover_colored: true,
    [`popover--${type}`]: !!type,
  });

  const arrowClassName = cx({
    'popover__arrow': true,
    [`popover__arrow--${type}`]: !!type,
  });

  const contentClassName = cx({
    'popover__content': true,
    [`popover__content--${type}`]: !!type,
  });

  const titleClassName = cx({
    'popover__title': true,
    [`popover__title--${type}`]: !!type,
  });

  if (!active) {
    return null;
  }

  return (
    <Tethered
      className={className}
      getTarget={getTarget}
      classPrefix="bs-tether"
      attachment={attachment}
      {...rest}
    >
      <div>
        <div className={arrowClassName} />
        {title && title.length > 0 && (
          <h3 className={titleClassName}>{title}</h3>
        )}
        <div className={contentClassName}>
          {children}
        </div>
      </div>
    </Tethered>
  );
}

BootstrapPopover.propTypes = {
  children: React.PropTypes.node.isRequired,
  getTarget: React.PropTypes.func.isRequired,
  active: React.PropTypes.bool,
  title: React.PropTypes.string,
  placement: React.PropTypes.string,
  type: React.PropTypes.string,
};

BootstrapPopover.defaultProps = {
  active: true,
};

export default BootstrapPopover;



/** WEBPACK FOOTER **
 ** ./src/components/popover/BootstrapPopover.jsx
 **/